"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullthrows = void 0;
function nullthrows(value, message) {
    if (value == null) {
        throw new Error(message || "Value is nullish");
    }
    return value;
}
exports.nullthrows = nullthrows;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibnVsbHRocm93cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9udWxsdGhyb3dzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLFNBQWdCLFVBQVUsQ0FBSSxLQUFnQixFQUFFLE9BQWdCO0lBQzlELElBQUksS0FBSyxJQUFJLElBQUksRUFBRSxDQUFDO1FBQ2xCLE1BQU0sSUFBSSxLQUFLLENBQUMsT0FBTyxJQUFJLGtCQUFrQixDQUFDLENBQUM7SUFDakQsQ0FBQztJQUNELE9BQU8sS0FBSyxDQUFDO0FBQ2YsQ0FBQztBQUxELGdDQUtDIn0=